import React, { Component } from "react";

class AddressBook extends Component {
  render() {
    return <div>AddressBook</div>;
  }
}

export default AddressBook;
